export default "__VITE_ASSET__Bfxowpuj__"